import React from 'react'
import MasonryDescriptionContainer from '../../../../Components/Miscellaneous/Gallery/MasonryGalleryDescription'

export default function MasonryGalleryDescription() {
  return (
    <div className='page-body'>
        <MasonryDescriptionContainer/>
    </div>
  )
}
